// variables.js
import Moment from "moment";

export var dateFuncs = {
	backEndDateFormat(date) {
		let formattedDate = Moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
		let valid = Moment(date).isValid();
		return valid == true ? formattedDate : null;
	},

	frontEndDateFormat(date) {
		let formattedDate = Moment(date).format("YYYY-MM-DD");
		let valid = Moment(date).isValid();
		return valid == true ? formattedDate : null;
	},

	humanDateFormat(date) {
		let formattedDate = Moment(date).format("DD MMM YYYY");
		let valid = Moment(date).isValid();
		return valid == true ? formattedDate : 'No date';
	},

	today() {
		return Moment(new Date()).format("YYYY-MM-DD");
	},

	daysAfterTomorrow(days) {
		let today = Moment(new Date());

		return Moment(today).add(days, 'days').format("YYYY-MM-DD");
	},

	getValidDate(date) {
		return Moment(date).isValid() ? Moment(date) : null;

	},

	isTimeAfter(date1, date2) {
		return Moment(date1).isAfter(date2, 'seconds');
	},

	getDifference(date) {
		var today = Moment();
		var _date = Moment(date);
		var after = Moment(_date).isAfter(today, 'weeks');	
		var diff = today.diff(_date, 'weeks');

		if (!after && diff != 0) {
			diff = -Math.abs(diff);
		}
		else {
			diff = Math.abs(diff);
		}
		return diff;
	},

	addTime(startDate, seconds) {
		let endDate = Moment(startDate).add(seconds, 'seconds');
		let valid = Moment(startDate).isValid();

		if (!Moment(startDate).isSame(endDate, 'day')) {
			valid = false;
		}

		return valid == true ? endDate.format("HH:mm") : null;
	},

	getTime(date) {
		date = '01/01/1981 ' + date;
		let time = Moment(date).format("HH:mm");
		let valid = Moment(date).isValid();
		return valid == true ? time : null;
	}
};


// WEBPACK FOOTER //
// ./src/globs.js